import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
	BreakpointWidth
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		formFramePopup_container: {
			overflow: 'hidden',
			position: 'relative',
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				width: '100%',
				height: '100%',
				margin: theme.spacing(0),
				maxWidth: '100%',
				maxHeight: 'none',
			},
		},
		formFramePopup_scrollbar: {
			height: '100%',
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				'& $formFramePopup_body': {
					flex: '1 0 auto',
				}
			},
		},
		formFramePopup_header: {
			flex: '1 0 auto',
		},
		formFramePopup_body: {

		},
		formFramePopup_footer: {

		},
		formFramePopup_dialog: {
			zIndex: `${theme.zIndex.tooltip} !important` as any,
		}
	});
});

export default useStyles;
